import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {LensFormMultiSelectAssignees} from './lensFormMultiSelectAssignees';
import {
  getInboxesInState,
  getTeammatesInCommon,
  LensFormMultiSelectTeammatesContainerProps,
} from './teammateFilterHelpers';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<LensFormMultiSelectTeammatesContainerProps>()(() => ({
  choices: getTeammatesInCommon,
  selectedInboxesInState: getInboxesInState,
}));

export const LensFormMultiSelectAssigneesContainer = connect(mapStateToProps)(LensFormMultiSelectAssignees);
